"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlState = void 0;
const react_1 = require("react");
const useUrlParams_1 = require("./useUrlParams");
function useUrlState(urlParamName, defaultState) {
    const [urlParams, setUrlParam] = useUrlParams_1.useUrlParams();
    const [state, setState] = react_1.useState(defaultState);
    react_1.useEffect(() => {
        setUrlParam(urlParamName, state);
    }, [setUrlParam, state, urlParamName]);
    return [state, setState];
}
exports.useUrlState = useUrlState;
